/**
 * Country code -> human label for the address form + country switcher.
 * Source of truth: `/api/intl/tiers` defines which codes we *ship* to,
 * this map just adds friendly display names for them.
 */
export const COUNTRY_LABELS = {
  IN: "India", US: "United States", CA: "Canada", GB: "United Kingdom",
  DE: "Germany", FR: "France", NL: "Netherlands", BE: "Belgium",
  IT: "Italy", ES: "Spain", AT: "Austria", SG: "Singapore",
  JP: "Japan", KR: "South Korea", NZ: "New Zealand",
  AE: "UAE", SA: "Saudi Arabia", MY: "Malaysia", TH: "Thailand",
  BR: "Brazil", MX: "Mexico", ZA: "South Africa", ID: "Indonesia",
  PH: "Philippines", CH: "Switzerland", NO: "Norway", DK: "Denmark",
  SE: "Sweden", FI: "Finland", IS: "Iceland", LU: "Luxembourg",
};

export const countryLabel = (code) =>
  COUNTRY_LABELS[(code || "").toUpperCase()] || code || "";

// Per-country labels for the postcode / state fields on the address form.
// Falls back to "Postal Code" / "State / Province" for any country not listed.
const POSTCODE_BY_COUNTRY = {
  IN: "Pincode",
  US: "ZIP Code", CA: "Postal Code", GB: "Postcode", AU: "Postcode",
  NZ: "Postcode", DE: "PLZ", FR: "Code postal", NL: "Postcode",
  BE: "Postcode", IT: "CAP", ES: "Código postal", AT: "PLZ",
  SG: "Postal Code", JP: "Postal Code", KR: "Postal Code",
  AE: "PO Box / Postal Code", SA: "Postal Code", MY: "Postcode",
  TH: "Postal Code", BR: "CEP", MX: "Código postal", ZA: "Postal Code",
  ID: "Postal Code", PH: "ZIP Code", CH: "PLZ", NO: "Postnummer",
  DK: "Postnummer", SE: "Postnummer", FI: "Postinumero", IS: "Póstnúmer",
  LU: "Code postal",
};

const STATE_BY_COUNTRY = {
  IN: "State", US: "State", CA: "Province", GB: "County",
  AU: "State / Territory", NZ: "Region", DE: "Bundesland",
  FR: "Region", JP: "Prefecture", BR: "State", MX: "State",
};

export const postcodeLabel = (code) =>
  POSTCODE_BY_COUNTRY[(code || "").toUpperCase()] || "Postal Code";

export const stateLabel = (code) =>
  STATE_BY_COUNTRY[(code || "").toUpperCase()] || "State / Province";
